"use client";

import type { PropsWithChildren } from "react";
import { IntlProvider } from "react-intl";
import type { IntlConfig } from "react-intl";

interface IntlProps {
  readonly locale: IntlConfig["locale"];
  readonly messages: IntlConfig["messages"];
}

export const Intl = ({
  locale,
  messages,
  children,
}: PropsWithChildren<IntlProps>) => (
  <IntlProvider locale={locale} messages={messages}>
    {children}
  </IntlProvider>
);
